import { gql } from "@apollo/client";

export const GET_INITIATIVES = gql`
  query GetInitiatives(
    $input: InitiativesInput!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $orderBy: InitiativeOrder
  ) {
    initiatives(
      input: $input
      first: $first
      after: $after
      last: $last
      before: $before
      orderBy: $orderBy
    ) {
      totalCount
      edges {
        cursor
        node {
          mrn
          title
          status
          createdAt
          updatedAt
          scoreDelta
          metadata {
            ... on AggregateInitiativeMetadata {
              assetCount
              fixedCount
              findingCount
              effort
              manualEffort {
                research
                rollout
                scripting
                verification
                totalManualEffort
              }
              securityPipelineSupportedCount
            }
            ... on AssetInitiativeMetadata {
              securityPipelineSupportedCount
            }
          }
          references {
            findingMrn
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
